/** @format */

export function noop() {}
